import React, { createContext, useReducer, useMemo } from 'react';
import PropTypes from 'prop-types';

import reducer from './Reducer';
import actions from './Actions';

const initialState = {
  enterpriseId: null,
  enterpriseName: '',
  enterpriseSizeId: null,
  enterpriseIndustryIds: [],
  enterpriseLogo: null,
  enterpriseColor: null,
  enterpriseBrandingAvailable: undefined,
};

const context = createContext();

export function ContextProvider({ enterpriseId, children }) {
  initialState.enterpriseId = enterpriseId;
  const [state, dispatch] = useReducer(reducer, initialState);

  const value = useMemo(() => ({
    state, dispatch, actions,
  }), [state, dispatch, actions]);

  return (
    <context.Provider value={value}>
      {children}
    </context.Provider>
  );
}

ContextProvider.propTypes = {
  enterpriseId: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
};

export const useContext = () => React.useContext(context);
